import { ThemeContext } from "../../providers";
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import RoutesConfig from "../../RoutesConfig";


export default function Content(props) {

  // const theme = useContext(ThemeContext);

  return (
    // <BrowserRouter>
      <Routes>
        {
          RoutesConfig.map((routeObject) => (
            <Route key={routeObject.name} path={routeObject.path} element={<routeObject.component />}></Route>
          ))
        }
      </Routes>
    // </BrowserRouter>
  )

}